import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';

export default function FeaturedComics() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 6);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-xs md:text-sm text-foreground-500 mt-1">
              本周最受欢迎的韩漫作品
            </p>
          </div>
          <Link
            to="/category/recommended"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-2" data-product-shop>
          {hotComics.map((comic) => (
            <div key={comic.id} className="flex-shrink-0">
              <ComicCard comic={comic} size="normal" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}